import { Lessons } from '@berlitz/icons'
import Calendar from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/21-Date-Calendar/Calendar1'
import PortalStudentProfile from '@classes/StudentProfile'
import DashboardCard from '@components/DashboardCard'
import { StoreProps } from '@interfaces/StoreState'
import { ProgramStudentInfo } from '@interfaces/Student'
import { isFlexProgram } from '@utils/helpers/sessions'
import React from 'react'
import { InjectedIntlProps, injectIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { StyledCol } from './style'

const CardSingleBook: React.FunctionComponent<ProgramStudentInfo & InjectedIntlProps> = ({
  ProgramType,
  ProgramId,
  SingleSessionScheduling,
  intl,
}) => {
  const { StudentProfile } = useSelector(({ userProfile }: StoreProps) => ({
    StudentProfile: new PortalStudentProfile(userProfile?.info.StudentProfile.StudentProfileInfo),
  }))

  let title = 'Book a single lesson'
  let icon = <Lessons />
  if (isFlexProgram(ProgramType)) {
    title = 'Book a live coaching session'
    icon = <Calendar />
  }
  return SingleSessionScheduling ? (
    <StyledCol xs={12} sm={6} md={6} lg={3}>
      <DashboardCard
        link={`/scheduling/single-lesson?programid=${ProgramId}&unitId=0000${
          StudentProfile.HasElectiveMaterial ? '&LPId=null' : ''
        }&entryPoint=calendar`}
        id="book-single-lesson-card"
        loading={false}
        icon={icon}
        title={intl.formatMessage({
          id: title,
        })}
      />
    </StyledCol>
  ) : null
}

export default injectIntl(CardSingleBook)
